var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"techcast-english"},[_c('navbar',{staticClass:"header"}),_vm._v(" "),_c('main',{staticClass:"main-en"},[_c('nuxt'),_vm._v(" "),_c('scroll-top-button')],1),_vm._v(" "),_c('page-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }